import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    Link,
    MenuItem,
    TextField,
    Toolbar,
    Tooltip,
    Typography,
} from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import {
    AddOutlined,
    ArrowBackIosOutlined,
    ArrowForwardIosOutlined,
    CalendarToday,
    Clear,
    Close,
    Search,
} from '@material-ui/icons'
import { KeyboardDatePicker } from '@material-ui/pickers'
import clsx from 'clsx'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'
import * as yup from 'yup'

import { showError, showSuccess } from '../../../../actions/misc/misc.actions'
import { updateFacilityPlaygroups } from '../../../../actions/playgroups/playgroups.actions'
import { getSpecificAreas, PLAYGROUP_STATUSES } from '../../../../utils'
import { MainButton } from '../../../Button/MainButton'
import DeleteConfirmation from '../../../Dialogs/DeleteConfirmation'
import { FilterButton } from '../../Components/Playgroups/FilterButton'
import { GroomingAssignmentFilterButton } from '../../Components/Schedule/GroomingAssignmentFilterButton'


const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
	},
	petStatusIcon: {
		position: 'absolute',
		left: 0
	},
	toolbarItemsWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		'& > *': {
			marginRight: '16px',
			marginBottom: 8
		}
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		backgroundColor: 'transparent',
		paddingTop: 16
	},
	searchField: {
		minWidth: 150
	},
	datePickerContainer: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative'
	},
	datePicker: {
		color: '#FFFFFF',
		opacity: 0,
		position: 'absolute',
		top: 0,
		height: 38,
		margin: 0,
		'& *': {
			height: 0,
			padding: 0,
			margin: 0
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	filterButton: {
		zIndex: 1
	},
	calendarDateButton: {
		zIndex: 1,
		border: '1px solid #D0CFD2',
		padding: '7px 16px 8px 24px',
		color: '#4D4C4F',
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: 16
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: 38,
		width: 38,
		padding: 5,
		'& svg': {
			height: 16
		}
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	scheduleAggregatesWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		paddingTop: '10px',
		paddingBottom: '12px'
	},
	scheduleAggregate: {
		display: 'flex',
		flex: '238px 0 0',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		padding: '10px 16px',
		borderRadius: 6,
		color: '#4D4C4F',
		marginRight: 8,
		marginBottom: 8,
		background: '#F3F3F3'
	},
	membershipWrapper: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	membershipIcon: {
		color: '#6B4AD6',
		'&::before': {
			fontSize: '14px',
			lineHeight: '14px'
		}
	},
	membershipType: {
		fontFamily: 'Nunito',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '19px',
		color: '#777679',
		textTransform: 'capitalize'
	},
	filterIcon: {
		fontSize: 19,
		color: '#777679',
		marginRight: 8
	},
	filterButtonLabel: {
		alignItems: 'center'
	},
	noWrap: {
		whiteSpace: 'nowrap'
	},
	dialogTitle: {
		justifyContent: 'space-between',
		alignItems: 'center',
		'& .MuiTypography-root': {
			width: '100%'
		},
		padding: '16px 24px 0px'
	},
	// form: {
	// 	width: '100%',
	// 	display: 'flex',
	// 	flexWrap: 'wrap',
	// 	justifyContent: 'space-between',
	// 	'& .MuiTextField-root, .MuiAutocomplete-root, .MuiFilledInput-root': {
	// 		// width: 270,
	// 		minWidth: 270
	// 		// minHeight: 40
	// 	}
	// },
	form: {
		display: 'flex',
		flexWrap: 'wrap',
		margin: '24px 0px',
		'& .MuiTextField-root': {
			minWidth: '274px !important'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '274px !important'
		}
	},
	row: {
		// display: 'flex',
		// width: '100%',
		// justifyContent: 'space-between',
		// marginBottom: 20,
		// height: 56,

		display: 'flex',
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	input: {
		width: '48%',
		marginBottom: 16,
		// minWidth: 419,
		'& input': {
			minHeight: 32,
			padding: '23px 12px 10px', // this avoids label overlapping
			backgroundColor: '#FFF',
			'&:hover': {
				//you want this to be the same as the backgroundColor above
				backgroundColor: '#FFF'
			}
		}
	},
	select: {
		width: '48%',
		marginBottom: 16,
		// minWidth: 419,
		'& [class*=MuiSelect-root]': {
			minHeight: 45,
			display: 'flex',
			alignItems: 'flex-end',
			backgroundColor: '#FFF',
			'&:hover': {
				//you want this to be the same as the backgroundColor above
				backgroundColor: '#FFF'
			}
		}
	},
	autocomplete: {
		// minWidth: 419
		width: '48%',
		marginBottom: 16,
		'& input': {
			minHeight: 36,
			// padding: '23px 12px 10px', // this avoids label overlapping
			backgroundColor: '#FFF',
			'&:hover': {
				//you want this to be the same as the backgroundColor above
				backgroundColor: '#FFF'
			}
		},
		'& [class*=MuiInputBase-root]': {
			backgroundColor: '#FFF',
			'&:hover': {
				//you want this to be the same as the backgroundColor above
				backgroundColor: '#FFF'
			}
		}
	},
	dialogActions: {
		justifyContent: 'flex-start',
		width: '100%',
		padding: '24px 0px'
	}
}))

const STATUSES = Object.entries(PLAYGROUP_STATUSES).map(([id, label]) => ({ id, label }))

const validationSchema = yup.object({
	name: yup.string().required(),
	playgroup_type_id: yup.string().required(),
	capacity: yup.string().required().min(0).max(99),
	kennel_block_id: yup.string(),
	default_status: yup
		.string()
		.required()
		.oneOf(STATUSES.map((t) => t.id))
})

export const GroomingToolbar = React.forwardRef((props, ref) => {
	const classes = useStyles()
	const theme = useTheme()
	const dispatch = useDispatch()

	const [search, setSearch] = useState('')
	const [isOpen, setIsOpen] = useState(false)
	const [isAddNewPlaygroupOpen, setIsAddNewPlaygroupOpen] = useState(false)
	const [playgroupToEdit, setPlaygroupToEdit] = useState(null)
	const [isDeleteOpen, setIsDeleteOpen] = useState(false)
	const [isDeleteLoading, setIsDeleteLoading] = useState(false)

	const selectedFacility = useSelector((state) => state.specific.facilities.selected)

	let {
		tableRef,
		date,
		setDate,
		changeDate,
		onSearchChange,
		title = 'Grooming Assignment',
		darkTitle = false,
		allowDateChange = true,
		allowFilter = false,
		containerStyles = null,
		allowAdd = false,
		addAppt,
		updateDate
	} = props

	const changeDateAndClose = (d) => {
		updateDate(d)
		setIsOpen(false)
	}


	return (
		<div ref={ref} className={classes.toolbarWrapper}>
			<Toolbar
				className={[
					classes.toolbar
				]}>
				<div className={classes.toolbarItemsWrapper}>
					{!darkTitle ? (
						<Typography
							variant="h6"
							color="primary"
							style={{
								fontSize: '22px',
								fontWeight: 800,
								lineHeight: '30px',
								whiteSpace: 'nowrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis'
							}}>
							{title}
						</Typography>
					) : (
						<Typography variant="h5" style={{ fontWeight: 800 }}>
							{title}
						</Typography>
					)}
					
					<GroomingAssignmentFilterButton />
					{allowDateChange && (
						<div className={classes.datePickerContainer}>
							<Button
								className={clsx(classes.headerButton, classes.calendarDateButton)}
								onClick={() => setIsOpen(true)}
								variant="outlined"
								endIcon={<CalendarToday style={{ height: 19, width: 19, fill: '#777679' }} />}
								classes={{
									label: classes.noWrap
								}}
								size="large">
								{moment(date).format('MMM D, YYYY')}
							</Button>
							<KeyboardDatePicker
								disableToolbar
								open={isOpen}
								onOpen={() => setIsOpen(true)}
								onClose={() => setIsOpen(false)}
								variant="inline"
								format="MM/DD/YYYY"
								margin="normal"
								id="start-date"
								label="Start Date"
								inputVariant="filled"
								value={date}
								onChange={changeDateAndClose}
								className={classes.datePicker}
								rightArrowIcon={
									<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
								}
								leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
								KeyboardButtonProps={{
									'aria-label': 'Start Date',
									className: classes.calendarButton
								}}
							/>
						</div>
					)}
					{allowDateChange && (
						<div style={{ display: 'flex' }}>
							<IconButton
								className={classes.dateChangeButton}
								onClick={() => changeDate('subtract')}
								style={{ marginRight: 8 }}>
								<ArrowBackIosOutlined style={{ fill: '#777679' }} />
							</IconButton>
							<IconButton className={classes.dateChangeButton} onClick={() => changeDate('add')}>
								<ArrowForwardIosOutlined style={{ fill: '#777679' }} />
							</IconButton>
						</div>
					)}
					<Button
						variant="outlined"
						className={clsx(classes.headerButton, classes.addAppointmentButton)}
						startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
						size="large"
						onClick={addAppt}>
						Appointment
					</Button>
				
				</div>
			</Toolbar>
			
		</div>
	)
})

